import type { ConnectedWalletRequirement } from '@/features/tradingSession/store';

/**
 * Deposits leave from the owner EOA (a transaction on the anchor chain) and
 * withdrawals are paid to it. Both require a wallet session, so a passkey or
 * social user who opens either tab is sent through the Connected Wallet window
 * with the reason.
 */
export const DEPOSIT_WALLET_REQUIREMENT: ConnectedWalletRequirement = {
    operation: 'Depositing',
    reason: 'anchorTransaction',
};
export const WITHDRAW_WALLET_REQUIREMENT: ConnectedWalletRequirement = {
    operation: 'Withdrawing',
    reason: 'security',
};
